module.exports = __webpack_public_path__ + "img/6-fourImg.6b229cbb.png";